import { useState, useEffect, useCallback } from "react";
import { deleteDoc, getDocs } from "firebase/firestore";
import { aoiCollectionRef, getAoiDoc } from "../utils/firestoreHelpers";
import Button from "react-bootstrap/Button";
import EditAOI from "../components/AddAOI";
import { Accordion, Modal, Table } from "react-bootstrap";

const AreaOfInterests = () => {
  const [data, setData] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [aoiTypes, setAoiTypes] = useState([]);

  const fetchDocs = useCallback(async () => {
    const data = await getDocs(aoiCollectionRef);
    const types = new Set();
    const data2 = data.docs.map((doc) => {
      const item = { ...doc.data(), id: doc.id };
      types.add(item.type);
      return item;
    });
    setAoiTypes([...types]);
    let test = data2.reduce((acc, curr) => {
      if (acc[curr.type]) {
        acc[curr.type].push(curr);
      } else {
        acc[curr.type] = [curr];
      }
      return acc;
    }, {});
    setData(
      [...types].map((type) => ({
        label: type,
        value: test[type],
      }))
    );
  }, []);

  const handleDeleteAOI = async () => {
    if (selected?.id) {
      const aoiDoc = await getAoiDoc(selected.id);
      // console.log("aoiDoc :: ", aoiDoc);
      await deleteDoc(aoiDoc);
      setData((prev) =>
        prev.map((group) => ({
          ...group,
          value: group.value.filter((item) => item.id !== selected.id),
        }))
      );
      fetchDocs();
    } else {
      // console.log("select item first");
    }
    setShowDeleteModal(false);
  };

  useEffect(() => {
    fetchDocs();
  }, [fetchDocs]);

  // console.log({ data });
  return (
    <>
      <header className="d-flex  justify-content-between mb-3">
        <h2>Area Of Interests</h2>
        <button className="btn btn-dark" onClick={() => setShowEditModal(true)}>
          Add
        </button>
      </header>
      <main>
        <Accordion alwaysOpen={false}>
          {data.map((item, index) => (
            <Accordion.Item eventKey={index.toString()} key={item.label}>
              <Accordion.Header>{item.label}</Accordion.Header>
              <Accordion.Body>
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.value.map((val) => (
                      <tr key={val.id}>
                        <td className="text-truncate" style={{ maxWidth: "200px" }} title={val.title}>{val.title}</td>
                        <td className="text-truncate" style={{ maxWidth: "200px" }} title={val.description}>{val.description}</td>
                        <td>
                          <Button
                            className=""
                            style={{ marginRight: "5px" }}
                            onClick={() => {
                              setSelected(val);
                              setShowEditModal(true);
                            }}
                          >
                            Edit
                          </Button>
                          <Button
                            className="btn btn-danger"
                            onClick={() => {
                              setSelected(val);
                              setShowDeleteModal(true);
                            }}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
        {/* {data.map((d) => (
          <Card style={{ width: "18rem" }} key={d.id}>
            <Card.Img variant="top" src={d.image_url} />
            <Card.Body>
              <Card.Title>{d.title}</Card.Title>
              <Card.Text>{d.link}</Card.Text>

              <Button
                variant="danger"
                onClick={() => {
                  setSelected(d);
                  setShowDeleteModal(true);
                }}
              >
                Delete
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  setSelected(d);
                  setShowEditModal(true);
                }}
              >
                Edit
              </Button>
            </Card.Body>
          </Card>
        ))} */}
      </main>
      {showEditModal ? (
        <EditAOI
          onClose={() => {
            setShowEditModal(false);
            setSelected(null);
          }}
          refresh={fetchDocs}
          data={selected}
          type_list={aoiTypes}
        />
      ) : null}
      {showDeleteModal ? (
        <ConfirmDeleteAOI
          confirmFunction={handleDeleteAOI}
          onClose={() => {
            setSelected(null);
            setShowDeleteModal(false);
          }}
          selected={selected}
        />
      ) : null}
    </>
  );
};

export default AreaOfInterests;

const ConfirmDeleteAOI = ({ onClose, confirmFunction, selected }) => {
  console.log("selected :: ", selected);
  return (
    <Modal show={true} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title>
          Are you sure you want to delete <br />
          <strong>{selected.title}</strong> ?
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          No
        </Button>
        <Button variant="danger" onClick={() => confirmFunction()}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
